var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9044305_document_pdf_icon",
    "data-name": "9044305_document_pdf_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40550",
    "data-name": "Path 40550",
    d: "M26.8,16.934V16H24v4.668h.934V18.8h1.4v-.934h-1.4v-.934Z",
    transform: "translate(-12.797 -8.531)",
    fill: "#394659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40551",
    "data-name": "Path 40551",
    d: "M16.867,20.668H15V16h1.867a1.4,1.4,0,0,1,1.4,1.4v1.867A1.4,1.4,0,0,1,16.867,20.668Zm-.934-.934h.934a.467.467,0,0,0,.467-.467V17.4a.467.467,0,0,0-.467-.467h-.934Z",
    transform: "translate(-7.998 -8.531)",
    fill: "#394659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40552",
    "data-name": "Path 40552",
    d: "M8.334,16H6v4.668h.934v-1.4h1.4a.935.935,0,0,0,.934-.934v-1.4A.935.935,0,0,0,8.334,16Zm-1.4,2.334v-1.4h1.4v1.4Z",
    transform: "translate(-3.199 -8.531)",
    fill: "#394659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40553",
    "data-name": "Path 40553",
    d: "M11.336,7.6V5.734a.424.424,0,0,0-.14-.327L7.928,2.14A.424.424,0,0,0,7.6,2H2.934A.936.936,0,0,0,2,2.933v11.2a.934.934,0,0,0,.934.934H10.4v-.934H2.934V2.933H6.668v2.8a.936.936,0,0,0,.934.934h2.8V7.6ZM7.6,5.734V3.12l2.614,2.614Z",
    transform: "translate(-1.066 -1.066)",
    fill: "#394659"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 15,
    height: 15,
    fill: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfGray);
export default __webpack_public_path__ + "static/media/pdf-gray.7f2213784f277185e11b24c52ed44d68.svg";
export { ForwardRef as ReactComponent };